import { Component, OnInit } from '@angular/core';
import { AuthService, LoginCredential } from '../auth.service';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit{

  toggle: boolean = false;
  email: string = '';
  password: string = '';

  constructor(private authService: AuthService, private dialogRef: MatDialogRef<LoginComponent>, private utilService: UtilitieService){
  }

  cancel(){
    this.dialogRef.close();
  }

  openMemberLogin(){
    this.dialogRef.close(null);
    setTimeout(() =>{
      this.authService.openMemberLogin();
    }, 1000);
  }

  toggleView(){
    if(this.toggle){
      this.toggle = false;
    }else{
      this.toggle = true;
    }
  }

  async login(form: NgForm){
    if(form.invalid){
      this.authService.openSnackBar('Check your inputs', '');
      return;
    }
  
    let credential: LoginCredential ={
      email: form.value.email,
      password: form.value.password
    }

    try{
      let authResponse = await this.authService.login(credential);
    
      if(authResponse){

        //this.authService.storeAuthToken(authResponse);
        this.authService.updateAuthState(authResponse);
        this.password = '';
        this.email = '';
        this.authService.openSnackBar('Login succesful','');
        this.dialogRef.close(authResponse);
        form.reset();

        return 
      }
  
      this.authService.openSnackBar('There was an error login in', 'please try again');

    }catch(err){
      this.authService.openSnackBar('There was an error login in', 'please try again');
    }
  }

  ngOnInit(): void {
    this.utilService.updateLoading(false);
  }

}
